import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgValidationCheckBold24 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M5.5 12.4423C7.25972 13.6468 10.3745 17.2039 11.3532 19.5C12.84 14.3996 16.6982 7.0596 18.6744 4.5" stroke="currentColor" strokeWidth={2.2} strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgValidationCheckBold24);
export default ForwardRef;